<template>
  <div>
    <v-layout>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <v-container fluid>
          <v-alert color="green" v-model="successChange" dismissible transition="scale-transition">
          {{ $t('userProfile.PASSWORD_SUCCESS') }}
          </v-alert>
          <v-alert color="green" v-model="successLanguageChange" dismissible transition="scale-transition">
            {{ $t('userProfile.LANGUAGE_SUCCESS') }}
          </v-alert>
          <v-alert color="green" v-model="successUpdateAcademicData" dismissible transition="scale-transition">
            {{ $t('userProfile.UPDATE_ACADEMIC_INFO_SUCCESS') }}
          </v-alert>
          <v-alert error v-model="failLanguageChange" dismissible transition="scale-transition">
            {{ $t('userProfile.LANGUAGE_FAILURE') }}
          </v-alert>
          <v-alert error v-model="failUpdateAcademicData" dismissible transition="scale-transition">
            {{ $t('userProfile.UPDATE_ACADEMIC_INFO_FAILURE') }}
          </v-alert>
          <v-tabs
            fixed
            icons
            centered
            v-model="active_tab">
            <v-tab href="#personal">
              <v-icon>account_box</v-icon>
              <span class="hidden-sm-and-down">{{ $t('newUser.STEP_PERSONAL') }}</span>
            </v-tab>
            <v-tab href="#school" :disabled="isExpert">
              <v-icon>account_balance</v-icon>
              <span class="hidden-sm-and-down">{{ $t('newUser.STEP_SCHOOL') }}</span>
            </v-tab>
            <v-tabs-items>
              <v-tab-item key="1" id="personal">
                <v-card>
                  <v-card-title>
                    <h3> {{ $t('userProfile.HEADING') }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn class="warning" @click.native.stop="dialogChangePassword = true">{{ $t('userProfile.PASSWORD_CHANGE') }}</v-btn>
                  </v-card-title>
                  <v-layout wrap>
                    <v-flex class="mt-2" xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.NAME')"
                        v-model="user.name"
                        required
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.SURNAME_1')"
                        v-model="user.surname1"
                        required
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.SURNAME_2')"
                        v-model="user.surname2"
                        disabled>
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.USERNAME')"
                        v-model="user.username"
                        type="email"
                        required
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-select
                        v-bind:items="languages"
                        item-text="shortname"
                        item-value="id"
                        v-model="user.defaultLanguageId"
                        :label="$t('user.LANGUAGE')"
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
                        <template slot="item" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-tab-item>
              <v-tab-item key="2" id="school">
                <v-card flat>
                  <v-layout wrap>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('newUser.GRADO_MASTER')"
                        v-model="user.degree"
                        required></v-text-field>
                    </v-flex>

                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('newUser.COURSE')"
                        v-model="user.course"
                        required></v-text-field>
                    </v-flex>

                    <v-flex xs8 offset-xs2>
                      <v-combobox
                        v-model="user.subjects"
                        :label="$t('newUser.SUBJECTS')"
                        :hint="$t('newUser.SUBJECTS_HINT')"
                        persistent-hint
                        append-icon=""
                        hide-no-data
                        deletable-chips
                        multiple
                        chips
                      ></v-combobox>
                    </v-flex>

                    <v-flex xs8 offset-xs2 mt-2>
                      <v-text-field
                        :label="$t('newUser.STUDENTS_NUMBER')"
                        v-model="user.studentsNumber"
                        type="number"
                        required></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-container>
      </v-flex>
    </v-layout>
    <v-btn fab large bottom right fixed class="green white--text" @click.native="updateButtonClick()" :disabled="!canPressUpdate"><v-icon>save</v-icon></v-btn>
    <v-layout row justify-center>
      <v-dialog v-model="dialogChangePassword" persistent max-width="70%">
        <v-card>
          <v-card-title class="headline">{{ $t('dialogs.changePassword.HEADER') }}</v-card-title>
          <v-layout wrap>
            <v-alert error v-model="failChange" dismissible>
              {{ $t('userProfile.PASSWORD_FAILURE') }}
            </v-alert>
            <v-flex class="mt-2" xs8 offset-xs2>
              <v-text-field
                :label="$t('dialogs.changePassword.PASSWORD')"
                v-model="newPassword.oldPassword"
                required
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                ></v-text-field>
            </v-flex>
            <v-flex xs8 offset-xs2>
              <v-text-field
                :label="$t('dialogs.changePassword.NEW_PASSWORD')"
                v-model="newPassword.newPassword"
                required
                :rules="passwordRules"
                :append-icon="e2 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (e2 = !e2)"
                :type="e2 ? 'password' : 'text'"
                ></v-text-field>
            </v-flex>
            <v-flex xs8 offset-xs2>
              <v-text-field
                :label="$t('dialogs.changePassword.REPEAT_NEW_PASSWORD')"
                v-model="newPassword.repeatedPassword"
                required
                :rules="repeatedPasswordRules"
                :append-icon="e3 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (e3 = !e3)"
                :type="e3 ? 'password' : 'text'"
                >
                ></v-text-field>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="darken-1" flat="flat" @click.native="dialogChangePassword = false">{{ $t('dialogs.changePassword.CANCEL') }}</v-btn>
            <v-btn color="warning" @click.native="changePassword" :disabled="!validPassword">{{ $t('dialogs.changePassword.OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
  import {AuthResource} from '../../api/auth'
  import {UserResource} from '../../api/user'
  import {LanguageResource} from '../../api/language'
  import {RoleResource} from '../../api/role'
  export default {
    name: 'profile',
    data () {
      return {
        variable: 'value',
        active_tab: 'personal',
        dialogChangePassword: false,
        user: {
          name: '',
          surname1: '',
          surname2: '',
          username: '',
          roleId: '',
          schoolId: '',
          degree: '',
          course: '',
          studentsNumber: '',
          defaultLanguageId: '',
          enabled: '',
          subjects: []
        },
        e1: true,
        e2: true,
        e3: true,
        successChange: false,
        failChange: false,
        successLanguageChange: false,
        failUpdateAcademicData: false,
        successUpdateAcademicData: false,
        failLanguageChange: false,
        repeatedPasswordRules: [
          (p) => this.newPassword.newPassword === this.newPassword.repeatedPassword || this.$t('login.MUST_MATCH')
        ],
        passwordRules: [
          (p) => p.length > 5 || this.$t('login.MINIM_PASS')
        ],
        languages: [],
        roles: [],
        newPassword: {
          oldPassword: '',
          newPassword: '',
          repeatedPassword: ''
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      var languages = []
      LanguageResource().get().then(
        response => {
          languages = response.data
          next(vm => {
            vm.languages = languages
          })
        },
        response => {
          console.log('error')
          next()
        }
      )
    },
    created () {
      RoleResource().get().then(
        response => {
          this.roles = response.data
        },
        response => {
          console.log('error in roles endpoint')
        }
      )
      UserResource().get({id: this.$auth.user().id}).then(response => {
        console.log(response.body)
        this.user = response.body
      }, response => {
        console.log(response)
      })
    },
    mounted () {
      LanguageResource().get().then(
        response => {
          this.languages = response.data
        },
        response => {
          console.log('error')
        }
      )
    },
    computed: {
      validPassword: function () {
        return (this.newPassword.oldPassword !== '' && this.newPassword.newPassword !== '' && this.newPassword.repeatedPassword !== '' &&
          this.newPassword.newPassword === this.newPassword.repeatedPassword && this.newPassword.newPassword.length > 5)
      },
      isExpert: function () {
        return (this.user.roleId !== '' && this.findItemById(this.roles, this.user.roleId).name === 'EXPERT')
      },
      canPressUpdate: function () {
        return ((this.active_tab === 'personal') || (this.active_tab === 'school' && this.user.studentsNumber !== '' && this.user.degree !== '' && this.user.course !== ''))
      }
    },
    methods: {
      findItemById: function (collection, id) {
        return this._.find(collection, function (i) {
          return i.id === id
        })
      },
      changePassword: function () {
        AuthResource().changePassword(this.newPassword).then(response => {
          this.dialogChangePassword = false
          this.failChange = false
          this.successChange = true
          this.resetPasswords()
        }, response => {
          this.failChange = true
          this.resetPasswords()
        })
      },
      resetPasswords: function () {
        this.newPassword.oldPassword = ''
        this.newPassword.newPassword = ''
        this.newPassword.repeatedPassword = ''
      },
      changeLanguage: function () {
        AuthResource().changeLanguage(this.user.defaultLanguageId).then(response => {
          var lang = this.findItemById(this.languages, this.user.defaultLanguageId).shortname
          this.$locale.change(lang)
          this.successLanguageChange = true
          this.failLanguageChange = false
        }, response => {
          this.successLanguageChange = false
          this.failLanguageChange = true
        })
      },
      updateBasicAcademicInfo: function () {
        const basicInfo = {
          degree: this.user.degree,
          course: this.user.course,
          studentsNumber: this.user.studentsNumber,
          subjects: this.user.subjects
        }
        UserResource().updateUniversityAcademicInfo(basicInfo).then(response => {
          this.successUpdateAcademicData = true
          this.failUpdateAcademicData = false
        }, response => {
          this.successUpdateAcademicData = false
          this.failUpdateAcademicData = true
        })
      },
      updateButtonClick: function () {
        if (this.active_tab === 'personal') {
          this.changeLanguage()
        } else {
          this.updateBasicAcademicInfo()
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/profile/Profile.vue